// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, bool, func, object, oneOfType, string } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ModalContainer from './ModalContainer'
import Trigger from './Trigger'

class MenuWrapper extends React.Component {
  static propTypes = {
    allRowsHighlighted: bool.isRequired,
    highlightedRows: array.isRequired,
    idRoot: string.isRequired,
    ModalTemplates: oneOfType([
      func.isRequired,
      object.isRequired,
    ]),
    Options: oneOfType([
      func.isRequired,
      object.isRequired,
    ]),
    sourceForm: string.isRequired,
    triggerSearch: func.isRequired,
  }

  state = {
    menuIsOpen: false,
    modalTemplate: null,
  }

  // ignores the click event and just triggers the modal to close
  closeModal = () => this.setModalTemplate()

  toggleMenu = () => (
    this.setState(({ menuIsOpen }) => ({
      menuIsOpen: !menuIsOpen,
    }))
  )

  setModalTemplate = (modalTemplate = null) => {
    this.setState(() => ({
      menuIsOpen: false,
      modalTemplate,
    }))
  }

  render () {
    const {
      closeModal,
      setModalTemplate,
      toggleMenu,
    } = this

    const {
      allRowsHighlighted,
      idRoot,
      highlightedRows,
      ModalTemplates,
      sourceForm,
      Options,
      triggerSearch,
    } = this.props

    const {
      menuIsOpen,
      modalTemplate,
    } = this.state

    return (
      <div className={'path-db-search-menu position-relative'}>
        <Trigger
          id={`${idRoot}menu-trigger`}
          menuIsOpen={menuIsOpen}
          toggleMenu={toggleMenu} />
        <Options
          hasHighlighted={!!highlightedRows.length}
          idRoot={idRoot}
          isOpen={menuIsOpen}
          setModalTemplate={setModalTemplate}
          sourceForm={sourceForm} />
        {
          modalTemplate &&
          <ModalContainer closeModal={closeModal}>
            <ModalTemplates
              allRowsHighlighted={allRowsHighlighted}
              closeModal={closeModal}
              highlightedRows={highlightedRows}
              idRoot={idRoot}
              modalTemplate={modalTemplate}
              sourceForm={sourceForm}
              triggerSearch={triggerSearch} />
          </ModalContainer>
        }
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  return {}
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
  }, dispatch)
)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuWrapper)
